module.exports = "https://cdn.realtymogul.com/static/media/social_linkedin_blue.59b82190.svg";